module.exports = __webpack_public_path__ + "img/mesa_hl27.1a9d7462.png";